/* 🤖 this file was generated by script */
export const wiconRossum = {
  name: 'rossum',
  data: `<svg viewBox="0 0 20 20"><circle cx="10" cy="10" r="8.42" fill="none" stroke="url(#paint0_linear)" stroke-width="1.5"/><defs fill="none"><linearGradient id="paint0_linear" x1="-.5" x2="20" y1="10" y2="10" fill="none" gradientUnits="userSpaceOnUse"><stop fill="none" offset="0%" stop-color="currentColor"/><stop fill="none" offset="100%" stop-color="currentColor" stop-opacity="0"/></linearGradient></defs></svg>`,
};
